import { render } from "./index.vue?vue&type=template&id=06a125d7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=06a125d7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06a125d7"

export default script